<template>
  <div ref="appContent" class="app-content">
    <div class="content-box">
      <div class="flex" style="align-items: center;justify-content: space-between;">
        <div class="flex" style="align-items: center;">
          <el-button type="text" icon="el-icon-search" @click="showOrderDialog">选择合同</el-button>
          <div style="color: red;font-size: 14px;margin-left: 20px;" v-if="!currentAgreement||!currentAgreement.id">
            请先选择要查看的合同
          </div>
        </div>
        <div class="flex" style="justify-content: flex-end">
          <FileLink file-type="back" v-if="btnBomExport" file-url="/erp/bom/export/settle" type="primary"
                    :params="{orderId:currentAgreement.id}">导出核价单
          </FileLink>
          <FileLink file-type="back" v-if="CostAnalysisGroupVisible" file-url="/erp/bom/export/settle" type="primary"
                    :params="{orderId:currentAgreement.id,needGroup:true}">导出核价单(分组)
          </FileLink>
          <el-button type="primary" size="mini" v-if="btnReportExport"
                     @click="doExport">订单统计下载
          </el-button>

          <el-button type="danger" size="mini" @click="completeOrder"
                     v-if="$hasPermission('order:set:status')&&currentAgreement&&currentAgreement.id&&currentAgreement.status!==200">
            完成合同
          </el-button>
          <el-button type="danger" size="mini" @click="resumeOrder"
                     v-if="$hasPermission('order:set:status')&&currentAgreement&&currentAgreement.id&&currentAgreement.status===200">
            恢复合同
          </el-button>
        </div>
      </div>
      <el-row :gutter="16" v-if="currentAgreement">
        <el-col :lg="6" :md="8">
          <div class="flex" style="align-items: center">
            <m-label label="合同编号" :value="currentAgreement.code"></m-label>
            <OrderStatusLabel :status="currentAgreement.status" style="margin-left: 20px"></OrderStatusLabel>
          </div>
        </el-col>
        <el-col :lg="6" :md="8">
          <m-label
              label="客户"
              :value="currentAgreement.customerName"
          ></m-label>
        </el-col>
        <el-col :lg="6" :md="8">
          <m-label
              label="合同总价"
              :value="currentAgreement.totalAmount"
          ></m-label>
        </el-col>
        <el-col :lg="6" :md="8">
          <m-label
              label="交易货币"
              :value="currentAgreement.currency"
          ></m-label>
        </el-col>
        <el-col :lg="6" :md="8">
          <m-label
              label="交付日期"
              :value="currentAgreement.deadline"
          ></m-label>
        </el-col>
        <el-col :lg="6" :md="8">
          <m-label
              label="业务担当"
              :value="currentAgreement.businessManName"
          ></m-label>
        </el-col>
        <el-col :lg="6" :md="8">
          <m-label
              label="操作人"
              :value="currentAgreement.creatorName"
          ></m-label>
        </el-col>
        <el-col :lg="6" :md="8">
          <m-label
              label="操作时间"
              :value="currentAgreement.createDate"
          ></m-label>
        </el-col>
        <el-col :lg="6" :md="8" v-if="$c.str2bool(currentAgreement.remark)">
          <m-label label="备注" :value="currentAgreement.remark"></m-label>
        </el-col>
      </el-row>
      <el-row :gutter="16" v-if="orderSettleGlobal">
        <el-col :lg="6">
          <m-label label="成品货值" :value="orderSettleGlobal.totalProductAmount"></m-label>
        </el-col>
        <el-col :lg="6">
          <m-label label="原材料货值" :value="orderSettleGlobal.totalMaterialAmount"></m-label>
        </el-col>
        <el-col :lg="6">
          <m-label label="应结加工费金额" :value="orderSettleGlobal.totalMakeAmount"></m-label>
        </el-col>
        <el-col :lg="6">
          <m-label label="实结加工费金额" :value="orderSettleGlobal.realMakeAmount"></m-label>
        </el-col>
      </el-row>
      <div style="margin-top:20px;">
        <el-tabs v-model="currentTab" type="card" @tab-click="tabClickHandler">
          <el-tab-pane label="订单明细" name="1" :lazy="true">
            <OrderDetail v-if="currentAgreement" :agreementId="currentAgreement.id"></OrderDetail>
          </el-tab-pane>
          <el-tab-pane label="采购合同" name="2" :lazy="true">
            <OrderPurchase v-if="currentAgreement" :agreementId="currentAgreement.id"></OrderPurchase>
          </el-tab-pane>
          <el-tab-pane label="生产合同" name="3" :lazy="true">
            <OrderMake v-if="currentAgreement" :agreementId="currentAgreement.id"></OrderMake>
          </el-tab-pane>
          <el-tab-pane
              label="发货箱单"
              name="4"
              :lazy="true"
              style="width:100%;"
          >
            <OrderBox v-if="currentAgreement" :agreementId="currentAgreement.id"></OrderBox>
          </el-tab-pane>
          <el-tab-pane
              label="成品库存"
              name="6"
              :lazy="true"
              style="width:100%;"
          >
            <store-count-table :show-opt="false" v-if="currentAgreement" :auto-load="false"
                               :order-id="currentAgreement.id"
                               productType="产品"></store-count-table>
            <!--            <OrderStore-->
            <!--                v-if="currentAgreement"-->
            <!--                productType="产品"-->
            <!--                :agreementId="currentAgreement.id"-->
            <!--            ></OrderStore>-->
          </el-tab-pane>
          <el-tab-pane
              label="成本核价单"
              name="8"
              :lazy="true"
              style="width:100%;"
          >
            <OrderBom
                v-if="currentAgreement"
                :agreementId="currentAgreement.id"
                ref="orderBom"
            ></OrderBom>
          </el-tab-pane>
          <el-tab-pane
              label="成本核价单(分组)"
              name="CostAnalysisGroup"
              :lazy="true"
              style="width:100%;"
          >
            <CostAnalysisGroup
                v-if="currentAgreement"
                :agreementId="currentAgreement.id"
                ref="CostAnalysisGroup"
            ></CostAnalysisGroup>
          </el-tab-pane>

          <el-tab-pane
              label="订单统计"
              name="9"
              :lazy="true"
              style="width:100%;"
          >
            <SettleReport
                v-if="currentAgreement&&currentAgreement.id"
                :order-id="currentAgreement.id"
                ref="SettleReport"
            ></SettleReport>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <OrderDialog ref="orderDialog" @change="orderChanged"></OrderDialog>
  </div>
</template>

<script>
import CostAnalysisGroup from '@/views/modules/settle/cost-analysis-group.vue'
import OrderDetail from '@/views/modules/common/order-detail'
import OrderPurchase from '@/views/modules/common/order-purchase'
import OrderMake from '@/views/modules/common/order-make'
import OrderBox from '@/views/modules/common/order-box'
import OrderImgs from '@/views/modules/common/order-imgs'
import OrderDialog from './order-dialog'
import OrderBom from './order-bom'
import StoreCountTable from '@/views/modules/StoreManager/common/store-count-table'
import SettleReport from './report/index.vue'
import FileLink from '@/components/FileLink.vue'

export default {
  mixins: [],
  components: {
    FileLink,
    OrderDetail,
    OrderPurchase,
    OrderMake,
    OrderBox,
    StoreCountTable,
    OrderImgs,
    OrderDialog,
    OrderBom,
    SettleReport, CostAnalysisGroup
  },
  data () {
    return {
      currentTab: '9',
      currentAgreement: {},
      orderSettleGlobal: {},
      orderBomVisible: false,
      settleReportVisible: true,
      CostAnalysisGroupVisible: false
    }
  },
  activated () {
    let orderId = localStorage.getItem('settle_order_id')
    if (orderId && !this.currentAgreement.id) {
      this.orderChanged({ id: orderId })
    }
  },
  watch: {},
  computed: {
    btnBomExport () {
      if (this.currentAgreement === null || this.currentAgreement === undefined) {
        return false
      }
      if (!this.$c.str2bool(this.currentAgreement.code)) {
        return false
      }
      if (!this.orderBomVisible) {
        return false
      }
      return true
    },
    btnReportExport () {
      if (this.currentAgreement === null || this.currentAgreement === undefined) {
        return false
      }
      if (!this.$c.str2bool(this.currentAgreement.code)) {
        return false
      }
      if (!this.settleReportVisible) {
        return false
      }
      return true
    }

  },
  methods: {
    doExport(){
      this.$export('/erp/settle/material/export',{orderId:this.currentAgreement.id})
    },
    refresh () {
      if (this.currentAgreement && this.currentAgreement.id) {
        this.orderChanged(this.currentAgreement)
      }
    },
    async resumeOrder(){
      await this.$confirm('是否恢复该合同?', '操作提示')
      const res = await this.$api2.post(`/trade/order/resume`, { id: this.currentAgreement.id })
      this.orderChanged(this.currentAgreement)
      this.$message.success('操作成功')
    },
    async completeOrder () {
      try{
      const checkRes=await this.$api2.get(`/trade/order/checkForComplete`,{params:{id: this.currentAgreement.id}})
      if(checkRes.unEndedStoreLogCount!=0||checkRes.unPayReceiptCount!=0){
        let msg=`该合同有`
        if(checkRes.unEndedStoreLogCount>0){
          msg+=`${checkRes.unEndedStoreLogCount}条未确认收货,`
        }
        if(checkRes.unPayReceiptCount>0){
          msg+=`${checkRes.unPayReceiptCount}条未开进项发票,`
        }
        await this.$confirm(msg+'是否继续?', '操作提示')
      }
      await this.$confirm('完成合同后该合同相关的操作将无法继续,是否执行该操作?', '操作提示')
      const res = await this.$api2.post(`/trade/order/complete`, { id: this.currentAgreement.id })
      this.orderChanged(this.currentAgreement)
      this.$message.success('操作成功')
      }catch (e){
        if(e!=='cancel'){
          console.log(e)
        }
      }
    },
    tabClickHandler (tab, event) {
      if (tab.name === '8') {
        this.$nextTick(() => {
          this.orderBomVisible = true
        })
      } else if (tab.name === '9') {
        this.$nextTick(() => {
          this.settleReportVisible = true
        })
      } else if (tab.name === 'CostAnalysisGroup') {
        this.$nextTick(() => {
          this.CostAnalysisGroupVisible = true
        })
      }
    },
    orderChanged (e) {
      let loading = this.$loading()
      this.$http.get(`/trade/agreement/${e.id}?calculate=1`).then(({ data: res }) => {
        this.currentAgreement = res.data
        localStorage.setItem('settle_order_id', res.data.id)
        this.queryOrderSettleGlobal(this.currentAgreement.id)
        loading.close()
      }).catch(e => {
        console.log(e)
        loading.close()
      })
    },
    showOrderDialog () {
      this.$refs.orderDialog.init()
    },
    //订单总体成本费用查询
    async queryOrderSettleGlobal (orderId) {
      try {
        const { data: res } = await this.$http.get(`/erp/order/settle/global`, { params: { orderId: orderId } })
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.orderSettleGlobal = res.data
      } catch (e) {
        console.log(e)
      }
    },

  },
}
</script>

<style lang="scss" scoped>
.app-content {
  background-color: #fff;
  padding: 20px;
  display: flex;

  .tree-box {
    width: 300px;
    height: calc(100vh - 110px);
    border-right: solid 1px #f7f7f7;
    margin-right: 20px;
    overflow-x: auto;
    overflow-y: auto;

    /deep/ .el-tree-node.is-expanded > .el-tree-node__children {
      display: inline;
    }
  }

  .content-box {
    width: calc(100%);
  }
}
</style>
